import React, { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { editBoxApi } from "../services/leitnerApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";
import mainContext from "../context/mainContext";

export default function EditBox({
  boxInfo,
  handleStartEditBox,
  handleBoxInfo,
}) {
  const { boxesList, handleEditBoxlist } = useContext(mainContext);

  const [editedBoxInfo, setEditedBoxInfo] = React.useState({});
  const [editedBoxProcess, setEditedBoxProcess] = React.useState(false);

  const handleEditBoxValue = (key, value) => {
    let cp = { ...editedBoxInfo };
    cp[key] = value;
    setEditedBoxInfo(cp);
  };
  const languages = {
    en: "انگلیسی",
    de: "المانی",
    fr: "فرانسوی",
    fa: "فارسی",
    tr: "ترکی",
    it: "ایتالیایی",
  };

  async function submit(e) {
    e.preventDefault();
    setEditedBoxProcess(true);
    handleStartEditBox(true);
    try {
      const response = await editBoxApi({
        boxId: editedBoxInfo["_id"],
        ...editedBoxInfo,
      });
      const res = checkResponseData(response);

      if (res["success"]) {
        toast.success(res["message"] || " ویرایش با موفقیت انجام شد");
        const newBoxList = [...boxesList];
        handleBoxInfo(editedBoxInfo);
        for (let index in newBoxList) {
          if (newBoxList[index]["_id"] == editedBoxInfo["_id"]) {
            newBoxList[index] = { ...newBoxList[index], ...editedBoxInfo };
          }
        }
        handleEditBoxlist(newBoxList);
        handleStartEditBox(false);
      } else {
        toast.error(res["message"] || "مشکلی در ذخیره اطلاعات وجود دارد");
      }
      setEditedBoxProcess(false);
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در ذخیره اطلاعات وجود دارد");
      setEditedBoxProcess(false);
      console.log(error);
    }
  }

  useEffect(() => {
    setEditedBoxInfo(boxInfo);
  }, []);
  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>ویرایش {editedBoxInfo.name}</h2>
      <form onSubmit={submit}>
        <label className="label">نام باکس</label>
        <input
          disabled={editedBoxProcess}
          className="input"
          value={editedBoxInfo.name}
          onChange={(e) => handleEditBoxValue("name", e.target.value)}
          required
        />

        <div className="row" style={{ marginTop: 12 }}>
          <div style={{ flex: 1, marginRight: 8 }}>
            <label className="label">زبان اول (لغات)</label>
            <select
              disabled={editedBoxProcess}
              className="input"
              value={editedBoxInfo.fromLang}
              onChange={(e) => handleEditBoxValue("fromLang", e.target.value)}
            >
              {Object.entries(languages).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1, marginLeft: 8 }}>
            <label className="label">زبان دوم (ترجمه)</label>
            <select
              disabled={editedBoxProcess}
              className="input"
              value={editedBoxInfo.toLang}
              onChange={(e) => handleEditBoxValue("toLang", e.target.value)}
            >
              {Object.entries(languages).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <label className="label" style={{ marginTop: 12 }}>
          توضیحات
        </label>
        <textarea
          disabled={editedBoxProcess}
          className="textarea"
          value={editedBoxInfo.description}
          onChange={(e) => handleEditBoxValue("description", e.target.value)}
        />
        {editedBoxProcess ? (
          <div style={{ justifyItems: "center" }}>
            <div className="spinner"></div>
            <p>در حال ذخیره</p>
          </div>
        ) : (
          <div
            className="row"
            style={{ marginTop: 16, justifyContent: "flex-end" }}
          >
            <button
              className="btn ghost"
              type="button"
              onClick={() => handleStartEditBox(false)}
            >
              انصراف
            </button>
            <button className="btn" type="submit">
              ذخیره
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
